<template>
  <div ref="modalRef" class="modal assertion-modal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <form class="modal-content">
        <div class="modal-header">
          <div>
            <h3 class="modal-title">
              {{ editSubjectTypeRef == ItemType.Person ? "Person detail" : "Family detail" }}
            </h3>
            <div v-if="isContextOwnedRef" class="help-text">
              Defined in this profile
            </div>
          </div>
          <button type="button" class="btn-close" :disabled="busyRef" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="isNewRef && spouseFamilySubjectsRef.length > 0" class="assertion-field">
            <label class="form-label">Subject type</label>
            <div class="subject-type">
              <select v-if="isNewRef" class="form-select" v-model="editSubjectTypeRef">
                <option v-for="t in subjectTypes" :value="t" :key="t">
                  {{ t }}
                </option>
              </select>
              <div class="input-value" v-else>
                  {{ editSubjectTypeRef }}
              </div>
            </div>
          </div>
          <div v-if="editSubjectTypeRef == ItemType.Family" class="assertion-field">
            <label class="form-label">Spouse</label>
            <div class="spouse-subject">
              <select v-if="isNewRef" class="form-select" v-model="editSubjectIdRef" :disabled="spouseFamilySubjectsRef.length < 2">
                <option v-for="sp in spouseFamilySubjectsRef" :value="sp.familyId" :key="sp.familyId">
                  {{ sp.spouse?.displayName }}
                </option>
              </select>
              <div class="input-value" v-else>
                  {{ subjectPersonRef?.displayName }}
              </div>
            </div>
          </div>
          <div class="assertion-field">
            <label class="form-label">Type</label>
            <div class="assertion-type">
              <img v-if="assertionTypeIcon && !isNewRef" :src="assertionTypeIcon"/>
              <select v-if="isNewRef" class="form-select" v-model="editTypeRef">
                <option v-for="d in sortedDefinitions" :value="d.type" :key="d.type">{{ d.type }}</option>
              </select>
              <div class="input-value" v-else>{{ assertionRef?.assertionType }}</div>
            </div>
          </div>
          <div v-if="definitionRef?.useDate" class="assertion-field">
            <label class="form-label">Date</label>
            <input type="text" class="form-control" v-if="canEditRef" placeholder="e.g., 1 Jan 2000" :readonly="busyRef" v-model="editDateRef"/>
            <div class="input-value" v-show="!canEditRef">{{ assertionRef?.date.toString(HistoricalDateFormat.LongDisplay) }}</div>
          </div>
          <template v-if="isNameRef">
            <div class="assertion-field">
              <label class="form-label">Given</label>
              <input type="text" class="form-control" v-if="canEditRef" :readonly="busyRef" v-model="editNameValue.given"/>
              <div class="input-value" v-show="!canEditRef">{{ nameValueRef?.given }}</div>
            </div>
            <div class="assertion-field">
              <label class="form-label">Surname</label>
              <input type="text" class="form-control" v-if="canEditRef" :readonly="busyRef" v-model="editNameValue.surname"/>
              <div class="input-value" v-show="!canEditRef">{{ nameValueRef?.surname }}</div>
            </div>
          </template>
          <div v-else-if="definitionRef?.useValue" class="assertion-field">
            <label class="form-label">Value</label>
            <select v-if="canEditRef && useValueListRef" class="form-select" v-model="editValueRef">
              <option v-for="v in valueListRef" :value="v.value" :key="v.value">{{ v.name }}</option>
              <option value="">Unknown</option>
            </select> 
            <input type="text" class="form-control" v-else-if="canEditRef" :readonly="busyRef" v-model="editValueRef"/>
            <div class="input-value" v-show="!canEditRef">{{ assertionRef?.value }}</div>
          </div>
          <!-- <div v-if="definitionRef?.useLocation" class="assertion-field">
            <label class="form-label">Place</label>
            <input type="text" class="form-control" v-if="isEditing" :readonly="!canEditValues" v-model="editAssertion.placeId"/>
            <div class="input-value" v-show="!isEditing">{{ assertionRef?.placeId }}</div>
          </div> -->
          <div v-if="!isContextOwnedRef" class="owner-profile">
            <label class="form-label">
              Defined in another profile
            </label>
            <ProfileCard :person-id="ownerPersonIdRef" show-profile-type/>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" v-if="canEditRef && !isNewRef" class="btn btn-outline-primary delete-action" :disabled="busyRef" @click="onDelete">
            Delete
          </button>
          <button type="button" v-if="!canEditRef" class="btn btn-primary" @click="close">
            Close
          </button>
          <button type="submit" v-if="canEditRef" class="btn btn-primary" :disabled="!canSaveRef || busyRef" @click.prevent="onSave">
            <Spinner v-if="busyRef"/>
            Save
          </button>
          <button type="button" v-if="canEditRef" class="btn btn-outline-primary" :disabled="busyRef" @click="close">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal-header {
  align-items: start;

  .help-text {
    margin-bottom: 0.5rem;
  }
}

.modal-body {
  min-height: 180px;
  padding: 0 1.5rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .help-text {
    margin-bottom: 1rem;
  }
}

.owner-profile {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.assertion-field {
  display: grid;
  grid-template-columns: 100px auto;
  column-gap: 0.5rem;
  align-items: center;

  .form-control, .input-value {
    margin-bottom: 0;
  }

  .assertion-type {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    img {
      width: 24px;
      opacity: 20%;
    }
  }
}

.modal-footer {
  button {
    min-width: 100px;
  }

  .delete-action {
    margin-right: auto;
  }
}
</style>

<script lang="ts" setup>
import { computed, nextTick, reactive, ref, watch } from 'vue'
import { useAssertionStore } from '@/rd/AssertionStore'
import { useAssertionTypeDefinitionStore } from '@/rd/AssertionTypeDefinitionStore'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { usePersonStore } from '@/rd/PersonStore'
import { useFamilyStore } from '@/rd/FamilyStore'
import { usePlaceStore } from '@/rd/PlaceStore'
import { Assertion, AssertionType, Gender, ItemType, PersonName, ViewFamily, ViewPerson } from '@/rd/ResearchDataModel'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { AssertionTypeIcons } from '@/explore/AssertionTypeIcons'
import { CompositeId } from '@/rd/CompositeId'
import { Modal as BsModal } from 'bootstrap'
import { ItemPermissions } from '@/gp/GroupAdminModel'
import { PatchChange } from '@/util/Api'
import { LoadMode } from '@/util/AsyncData'
import { assignExisting } from '@/util/TypeScriptUtil'
import { HistoricalDate } from '@/rd/HistoricalDate'
import { HistoricalDateFormat } from '@/rd/HistoricalDateEnums'
import { SortDate } from '@/rd/SortDate'
import { AsyncUtil } from '@/util/AsyncUtil'
import { Trash2Icon } from '@zhuowenli/vue-feather-icons'
import { useModalAutoHide } from '@/util/AppUtil'
import Spinner from '@/util/Spinner.vue'
import ProfileCard from './ProfileCard.vue'
import Modal from '@/util/Modal.vue'

const props = defineProps<{
  contextPersonId?: string
}>()

const emit = defineEmits<{
  (e: 'delete', assertionId?: string): void
}>()

defineExpose({
  open,
  reset: () => busyRef.value = false,
  close,
})

const subjectTypes = [
  ItemType.Person,
  ItemType.Family,
]

interface SpouseFamilySubject {
  familyId: string
  viewFamily: ViewFamily
  spouseId?: string
  spouse?: ViewPerson
}

const valueListRef = [
  { value: Gender.Male, name: Gender.Male },
  { value: Gender.Female, name: Gender.Female },
]

const busyRef = ref(false)
const ownerPersonIdRef = ref<string>()
const assertionRef = ref<Readonly<Assertion>>()
const editSubjectTypeRef = ref(ItemType.Person)
const editSubjectIdRef = ref('')
const editTypeRef = ref<string>()
const editDateRef = ref<string>()
const editValueRef = ref<string>()
const editNameValue = reactive(new PersonName())
const modalRef = ref<HTMLElement>()

const assertionStore = useAssertionStore()
const dataGroupStore = useDataGroupStore()
const familyStore = useFamilyStore()
const definitionStore = useAssertionTypeDefinitionStore()
const personStore = usePersonStore()
const viewPersonStore = useViewPersonStore()
const placeStore = usePlaceStore()

useModalAutoHide(modalRef)

const contextPersonRef = computed(() => personStore.getLoadedPersonList([props.contextPersonId]).at(0))
const contextViewPersonRef = computed(() => viewPersonStore.getLoadedPerson(props.contextPersonId))
const spouseFamilySubjectsRef = computed(() => {
  if (!props.contextPersonId || !contextViewPersonRef.value)
    return []

  // get spouse families with a matching family in the current person's group
  const contextGroupIdRef = CompositeId.getGroupId(props.contextPersonId)!
  const spFams = viewPersonStore.getLoadedSpouseFamilies(props.contextPersonId)
  const spFamSubjects = [] as SpouseFamilySubject[]
  for (const vf of spFams.spouseFamilies) {
    var personFamId = isNewRef.value
      ? vf.matchIds.find(id => CompositeId.hasGroupId(id, contextGroupIdRef)) // only include context-owned families
      : vf.id
    var spouseId = vf.spouseOf(contextViewPersonRef.value.id!)
    if (personFamId) {
      spFamSubjects.push({
        familyId: personFamId,
        viewFamily: vf,
        spouseId,
        spouse: viewPersonStore.getLoadedPerson(spouseId)
      })
    }
  }
  return spFamSubjects
})
const subjectPersonRef = computed(() => {
  if (editSubjectTypeRef.value == ItemType.Person)
    return contextPersonRef.value

  const sf = spouseFamilySubjectsRef.value.find(sf => sf.viewFamily.matchIds.includes(editSubjectIdRef.value))
  return sf?.spouse
})
const dataGroupIdRef = computed(() => CompositeId.getGroupId(assertionRef.value?.subjectId))
const isNewRef = computed(() => !assertionRef.value?.id)
const permissionsRef = computed(() => dataGroupStore.getAsyncPermissions(dataGroupIdRef.value, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)
const canModifyRef = computed(() => (permissionsRef.value & ItemPermissions.Modify) != 0)
const dataGroupRef = computed(() => dataGroupStore.getAsyncGroup(dataGroupIdRef.value, LoadMode.EnsureLoaded)?.data)
const isTrackingRef = computed(() => !!dataGroupRef.value?.trackedGroupId)
const canEditRef = computed(() => (isNewRef.value || assertionRef.value?.profile) && canModifyRef.value && !isTrackingRef.value && isContextOwnedRef.value)
const isContextOwnedRef = computed(() => ownerPersonIdRef.value == props.contextPersonId)

const assertionTypeIcon = computed(() => AssertionTypeIcons.getIcon(editTypeRef.value))
const definitionRef = computed(() => definitionStore.getAsyncDefinition(editTypeRef.value, LoadMode.EnsureLoaded)?.data)

const isNameRef = computed(() => editTypeRef.value == AssertionType.Name)
const nameValueRef = computed(() => isNameRef.value ? new PersonName(assertionRef.value?.value) : undefined)
const editDateValueRef = computed(() => HistoricalDate.parseUserInput(editDateRef.value))

const sortedDefinitions = computed(() => definitionStore.getDefinitionsForCommon(LoadMode.EnsureLoaded)
  .filter(d => assertionRef.value && d.subjectTypes.includes(editSubjectTypeRef.value))
  .sort((a, b) => a.type!.localeCompare(b.type!)))

const useValueListRef = computed(() => editTypeRef.value == AssertionType.Gender)

const hasChangesRef = computed(() => {
  return assertionRef.value && (
    isNewRef.value ||
    editSubjectTypeRef.value != assertionRef.value.subjectType ||
    editSubjectIdRef.value != assertionRef.value.subjectId ||
    editTypeRef.value != assertionRef.value.assertionType ||
    (definitionRef.value?.useDate && !editDateValueRef.value.equals(assertionRef.value.date)) ||
    (definitionRef.value?.useValue && editValueRef.value != assertionRef.value.value)
  )
})
const canSaveRef = computed(() => !!editTypeRef.value && hasChangesRef.value)

watch(editSubjectTypeRef, () => {
  // only react when subject type is editable (new assertion)
  if (isNewRef.value) {
    if (editSubjectTypeRef.value == ItemType.Person) {
      editSubjectIdRef.value = ownerPersonIdRef.value!
    }
    else if (spouseFamilySubjectsRef.value.length > 0) {
      editSubjectIdRef.value = spouseFamilySubjectsRef.value[0].familyId
    }
  }
})

watch(editNameValue, () => {
  editValueRef.value = editNameValue.getValue()
})

function open(assertionId?: string) {
  if (assertionId) {
    assertionRef.value = assertionStore.getAsyncAssertion(assertionId)!.data! // loaded by parent

    if (assertionRef.value.subjectType == ItemType.Person) {
      // owner is the assertion subject
      ownerPersonIdRef.value = assertionRef.value.subjectId
    }
    else if (assertionRef.value.profile) {
      // NOTE: in a profile, only spouse families can have assertions (not parent or other placeholder families)
      const dataGroup = dataGroupStore.getLoadedGroup(CompositeId.getGroupId(assertionId)) // loaded by parent
      ownerPersonIdRef.value = dataGroup?.startItemId
    }
    else {
      // NOTE: in a research group, the "owner" profile for a family is the father if present, otherwise the mother
      const family = familyStore.getLoadedFamily(assertionRef.value.subjectId!)! // loaded by parent
      ownerPersonIdRef.value = family.fatherId ?? family.motherId
    }
  }
  else {
    const newAssertion = new Assertion()
    newAssertion.subjectId = props.contextPersonId
    newAssertion.subjectType = ItemType.Person
    assertionRef.value = newAssertion

    ownerPersonIdRef.value = props.contextPersonId
  }

  if (modalRef.value && assertionRef.value) {

    editSubjectTypeRef.value = assertionRef.value.subjectType!
    editSubjectIdRef.value = assertionRef.value.subjectId!
    editTypeRef.value = assertionRef.value.assertionType
    editDateRef.value = assertionRef.value.date.toString(HistoricalDateFormat.LongDisplay)
    editValueRef.value = assertionRef.value.value
    if (isNameRef.value) {
      assignExisting(editNameValue, new PersonName(editValueRef.value))
    }

    // HACK: Not sure why getInstance isn't sufficient here, but sometimes it returns null because apparently the BS Modal
    // hasn't been initialized yet. Calling getOrCreateInstance seems to fix it.
    BsModal.getOrCreateInstance(modalRef.value).show()
  }
}

function close() {
  BsModal.getInstance(modalRef.value!)!.hide()
}

async function onSave() {
  if (assertionRef.value && canSaveRef.value) {

    try {
      busyRef.value = true

      const modAssertion = new Assertion()
      assignExisting(modAssertion, assertionRef.value!)

      modAssertion.subjectType = editSubjectTypeRef.value
      modAssertion.subjectId = editSubjectIdRef.value
      modAssertion.assertionType = editTypeRef.value!

      if (definitionRef.value!.useDate) {
        const dateValue = editDateValueRef.value
        modAssertion.date = dateValue
        modAssertion.sortDate = SortDate.parse(dateValue.sortValue)
      }

      if (definitionRef.value!.useValue) {
        modAssertion.value = editValueRef.value
      }

      if (isNewRef.value) {
        const groupId = CompositeId.getGroupId(modAssertion.subjectId)!
        await AsyncUtil.atLeast(500, assertionStore.addAsync(groupId, modAssertion))
      }
      else {
        const changes: PatchChange[] = []

        // HACK: patchAsync requires protocol format, unlike addAsync
        const dateValueString = modAssertion.date.toString()
        if (dateValueString != assertionRef.value!.date.toString()) {
          changes.push(new PatchChange('/date', dateValueString))
        }
        if (modAssertion.value != assertionRef.value!.value) {
          changes.push(new PatchChange('/value', modAssertion.value))
        }

        await AsyncUtil.atLeast(500, assertionStore.patchAsync(assertionRef.value.id!, changes))
      }
    }
    finally {
      busyRef.value = false
    }

    close()
  }
}

async function onDelete() {
  emit('delete', assertionRef.value?.id)
}
</script>
